<template>
  <div v-if="popupType">
    <div class="overlay"></div>
    <div class="popup guide">
      <div class="popup-content" v-if="popupType == 'notSelecetdCoin'" >
        <h5 class="highlight highlight__400 gradient">
          {{ $t('trading.common.selectCoins')}}
        </h5>
      </div>
      <div class="popup-content" v-else-if="popupType == 'notSubscribe'">
        <h5  class="highlight highlight__400 gradient">
          {{ $t('notSubscribe.msgSub01')}}
        </h5>
        <h5  class="highlight highlight__400 gradient" v-html="$t('notSubscribe.msgSub02')"></h5>
      </div>
      <div class="popup__btns">
        <button @click="closePopup(popupType)">
          <p>{{ $t("chart1.close") }}</p>
        </button>
      </div>
    </div>
  </div>
  </template>
  
<script setup>
import { useStore } from "vuex";
import { ref, computed, watch } from "vue";

const store = useStore();
const visible = ref(false);
const homeUrl = process.env.VUE_APP_HOME_URL
const popupType = ref(null);

let userInfo = computed(() => store.state.userInfo.risingUserInfo);

// 닫기 함수
function closePopup(popupType) {
  if (popupType == 'notSelecetdCoin') {
    location.href = `${homeUrl}/settings/dashboard?menuName=settings&tab=selectCoin`
  }
  else {
    location.href = `${homeUrl}/price/chart?menuName=price_kibot_chart`
  }
}

watch(
  () => userInfo.value,
  (newVal) => {
    if (userInfo.value?.user_no) {
      popupType.value = null;

      // if (newVal?.chart?.subsc_status == 203) {
      //   popupType.value = 'notSelecetdCoin'
      // }
  
      // else 
      if (newVal && !newVal.chart) {
        popupType.value = 'notSubscribe'
      }
    }
  },
  { immediate: true }
)

</script>
  
<style lang="scss" scoped>
@import "@/assets/scss/commons/modal/referral.scss";
</style>